import { createTransferCheckedInstruction, TOKEN_PROGRAM_ID } from "@solana/spl-token0.3.8";
import type { Connection, PublicKey, TransactionInstruction } from "@solana/web3.js";
import { convert, STEP_FEE_ADDRESS } from "@stepfinance/common";
import BigNumber from "bignumber.js";

import { COMPOUND_MODAL_FEE } from "../constants/compound";
import { findOrCreateAccountByMint } from "./account";

export const calculateFeeToTake = (totalAmount: number, decimals: number, forDisplay = false) => {
  const total = new BigNumber(totalAmount).multipliedBy(new BigNumber(10).exponentiatedBy(decimals));
  const fee = Math.round(total.multipliedBy(COMPOUND_MODAL_FEE / 100).toNumber());
  const rewardClaimedAfterFee = total.minus(fee).toNumber();
  return {
    fee,
    rewardClaimedAfterFee: forDisplay ? convert(rewardClaimedAfterFee, decimals) : rewardClaimedAfterFee,
  };
};

export const createInstructionsToTakeFee = async (
  connection: Connection,
  wallet: any,
  tokenMint: PublicKey,
  tokenDecimals: number,
  pendingReward: number | null | undefined,
  rewardAccount: PublicKey,
) => {
  const createAccountInstructions: TransactionInstruction[] = [];
  const feeInstructions: TransactionInstruction[] = [];

  if (pendingReward) {
    const stepAddressForCoin = await findOrCreateAccountByMint(
      connection,
      wallet.publicKey,
      STEP_FEE_ADDRESS,
      createAccountInstructions,
      tokenMint,
    );
    const { fee } = calculateFeeToTake(pendingReward, tokenDecimals);

    feeInstructions.push(
      createTransferCheckedInstruction(
        rewardAccount,
        tokenMint,
        stepAddressForCoin,
        wallet.publicKey,
        fee,
        tokenDecimals,
        [],
        TOKEN_PROGRAM_ID,
      ),
    );
  }
  return {
    createAccountInstructions,
    feeInstructions,
  };
};
